module.exports = __webpack_public_path__ + "./docs/img/big-icon-folder.f71116f01f385710af4f05494506b9ad.svg";